<div class="photo-grid"
     [class.photo-grid--fixed]="thumbnailSize"
     [style.--thumb-size]="thumbnailSize ? thumbnailSize + 'px' : null"
     *ngIf="images.length > 0"
     data-testid="assertion-gallery-list">
  <div class="photo-cell"
       *ngFor="let image of visibleImages; let i = index; trackBy: trackByMedia"
       (click)="openImagesModal(i)"
       [class.clickable]="!readonly"
       data-testid="assertion-gallery-item">

    <img [src]="getImageUrl(image)"
         [alt]="image.name || i"
         class="gallery-image"
         loading="eager"
         data-testid="assertion-gallery-img" />
  </div>

  <!-- Opens on the first image the tile is standing in for. -->
  <div class="photo-cell photo-cell--overflow"
       *ngIf="hiddenImageCount > 0"
       (click)="openImagesModal(visibleImages.length)"
       [class.clickable]="!readonly"
       data-testid="assertion-gallery-overflow">
    <span>+{{ hiddenImageCount }}</span>
  </div>
</div>

<div class="no-images-message"
     *ngIf="images.length === 0"
     data-testid="assertion-gallery-container-empty">
  <i class="pi pi-image"></i>
  <span>No images attached</span>
</div>